import React from "react";
import FakeFilters from "./filters";
import FakeCardDevice from "./card";
import style from "./style";
import style2 from "@/containers/devices/style";
const FakeDevices = () => {
  return (
    <section className="container fake-devices">
      <div className="productsContainer">
        <div className="filtersContainer">
          <FakeFilters />
        </div>
        <div className="devicesContainer">
          <div className="devicesHeader">
            <div style={{ width: "100%" }}>
              <div className="fake-devices--header">
                <div
                  className="skeleton fake-filters--row--small"
                  style={{ height: "25px", width: "190px" }}
                />
                <div
                  className="skeleton fake-filters--row--small display-block"
                  style={{ height: "25px", width: "440px" }}
                />
              </div>
              <div className="fake-devices--header">
                <div
                  className="skeleton fake-filters--row--small display-mobile"
                  style={{ height: "25px", width: "33%" }}
                />
                <div
                  className="skeleton fake-filters--row--small display-block display-mobile"
                  style={{ height: "35px", width: "50%" }}
                />
              </div>
              <div className={"devicesMap"}>
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
                <FakeCardDevice />
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{style}</style><style jsx>{style2}</style>
    </section>
  );
};

export default FakeDevices;
